/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
export const CALL_HISTORY_METHOD = 'CALL_HISTORY_METHOD';

function editLocation(method) {
  return (...args) => ({
    type: CALL_HISTORY_METHOD,
    payload: { method, args }
  });
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they accessToken to
 * your reducer and reissue them as the matching function on your history.
 */
export const push = editLocation('push');
export const replace = editLocation('replace');
export const go = editLocation('go');
export const goBack = editLocation('goBack');
export const goForward = editLocation('goForward');

export const routerActions = { push, replace, go, goBack, goForward };
